import axios from 'util/axiosConfig';

export const getDashboardCounts = async (role) => {
    return await axios.get(`/api/v1/dashboard-counts`, {
        params: {
            role
        }
    })
        .then(function (response) {
            if (response.data) {
                return { success: true, data: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error };
        });
}

export const getGroupAdminDashboardCountsAPI = async () => {
    return await axios.get(`/api/v1/groupadmin/dashboard-counts`).then(function (response) {
        if (response.data) {
            return {
                success: true,
                data: response.data.dashboard
            };
        } else {
            return { success: false };
        }
    }).catch(function (error) {
        return { success: false, error };
    });
}

export const getDashboardModalityCountsAPI = async (payload) => {

    let role = (payload).split("_");
    return await axios.get(`/api/v1/dashboard-modality-worklist-counts`, {
        params: {
            'role': role[1]
        }
    })
        .then(function (response) {
            if (response.data) {
                return { success: true, data: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error };
        });
}

export const resetAuthenticatorQrAPI = async(userId) => {
    return await axios.get(`/api/v1/reset-qr?userId=${userId}`)
        .then(function (response) {            
            if (response.status === 200) {
                return { success: true};
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error };
        });
}